<template>
    <div class="CensusDashboardPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-lg-3 col-xl-2">
                    <div class="paper olive-green">
                        <b-nav pills vertical class="side-menu">
                            <b-nav-item v-on:click="ChangePaneShown('Snapshot')" v-bind:class="{ active: PaneShown == 'Snapshot' }"><font-awesome-icon :icon="['fa', 'camera']" /> Snapshot</b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('Changes')" v-bind:class="{ active: PaneShown == 'Changes' }"><font-awesome-icon :icon="['fa', 'camera']" /> Changes</b-nav-item>
                        </b-nav>
                    </div>
                </div>
                <div class="col-lg-9 col-xl-10">
                    <div class="paper">
                        <div class="tab-content col-12">
                            <div v-if="PaneShown == 'Snapshot'">
                                <CensusSnapshot />
                            </div>
                            <div v-if="PaneShown == 'Changes'">
                                <CensusChanges />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faHome } from '@fortawesome/free-solid-svg-icons';
    library.add(faHome);
    import { faCamera } from '@fortawesome/free-solid-svg-icons';
    library.add(faCamera);
    //import components
    import CensusSnapshot from "./CensusSnapshot.vue";
    import CensusChanges from "./CensusChanges.vue";


    export default {
        props: [],
        data: function () {
            return {
                PaneShown: "Snapshot"
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            }
        },
        computed: {
            
        },
        components: {
            CensusSnapshot,
            CensusChanges
        }
    }
</script>

<style scoped>
</style>